<template>
    <div id="information" class="mainContainer bgGray pbottom50">
        <Banner></Banner>
        <div class="info_list_box w11 mtop30" v-if="hasNews">
            <!-- 通知公告列表 -->
            <div class="noticeList">
                <div class="info_list_content">
                    <div class="index-info-news-list" v-if="!hasNotice">
                        <el-empty description="暂无通知公告信息"></el-empty>
                    </div>
                    <div v-else>
                        <div
                            class="info_list_item"
                            v-for="noticeItem in noticeList"
                            :key="noticeItem.id"
                            @click="enterNoticeDetail(noticeItem.id)"
                        >
                            <p>{{ noticeItem.title }}</p>
                            <span>{{ noticeItem.updateDate }}</span>
                        </div>
                        <!-- 分页器 -->
                        <div class="block page_box mtb30">
                            <el-pagination
                                layout="prev, pager, next"
                                :page-size="noticePageObj.size"
                                :background="true"
                                :total="noticePageObj.total"
                                @current-change="noticeCurrentChange"
                            >
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Banner from "views/PcViews/Learn/Train/Notice/Banner";
import { PcCookie, Key } from "@/utils/cookie";
import { getCategoryNotifyList } from "api/train";
export default {
    components: { Banner },
    computed: {
        //是否有通知公告信息
        hasNotice() {
            return this.noticePageObj.total == 0 ? false : true;
        },
    },
    data() {
        return {
            //通知公告分页器
            noticePageObj: {
                page: 1,
                size: 12,
                total: 0,
            },
            //通知公告列表
            noticeList: [],
            hasNews:false
        };
    },
    created() {
        this.trainId = this.$route.query.trainId;
        this.fetchNoticListData();
    },
    methods: {
        //进去通知公告详情
        enterNoticeDetail(noticeId) {
            this.$router.push({
                path: "/pcViews/learn/train-notice-details",
                query: {
                    noticeId,
                },
            });
        },
        //通知公告分页器切换
        noticeCurrentChange(current) {
            //分页数切换
            this.noticePageObj.page = current;
            this.fetchNoticListData();
        },
        //获取通知公告列表信息
        fetchNoticListData() {
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getCategoryNotifyList(sessionId,this.trainId,this.noticePageObj.page,this.noticePageObj.size).then(res => {
                let { success, errorCode, body, msg } = res;
                if (success && errorCode == "2000") {
                    this.noticeList = body.data.list;
                    this.noticePageObj.total = body.data.count;
                    this.hasNews = true;
                }else{
                    this.$message({
                        message: msg,
                        type: 'error'
                    });
                }
            })
        },
    },
};
</script>

<style>
.info_list_tabs_box .el-tabs__header {
    margin: 0;
}
.info_list_tabs_box .el-tabs__item {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
}
.info_list_tabs_box .el-tabs__item.is-active,
.course_info_tabs .el-tabs__item:hover {
    color: #133d93;
}
.info_list_tabs_box .el-tabs__active-bar {
    background-color: #133d93;
}
</style>

<style lang="less" scoped>
.info_list_item:hover p,
.info_list_item:hover span {
    color: #133d93;
}
.info_list_item:hover {
    border-color: #133d93;
}
.info_list_item span {
    display: block;
    width: 186px;
    text-align: right;
    font-size: 12px;
    color: #a6a6a6;
}
.info_list_item p {
    max-width: calc(100% - 186px);
    font-size: 14px;
    color: #000;
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.info_list_item {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    padding: 6px 24px;
    height: 48px;
    border-bottom: dashed 1px #d3d3d3;
    justify-content: space-between;
    cursor: pointer;
}
.info_list_adress img {
    margin-right: 12px;
}
.info_list_adress {
    position: absolute;
    right: 24px;
    top: 16px;
    width: 154px;
    height: 54px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.info_list_tabs_box {
    padding-top: 20px;
    height: 60px;
    position: relative;
}
.info_list_box {
    padding: 0 20px;
    background: #fff;
    box-shadow: 0px 0px 9px 0px rgba(40, 40, 40, 0.2);
    overflow: hidden;
}
</style>
